import React, { useState, useEffect,useRef } from "react";
import { FaTimes } from "react-icons/fa";
import icons from "../../../icons.config";
const AddressSubmitPopup = ({ onClose }) => {
   useEffect(() => {
       document.body.classList.add("overflow-hidden");
       return () => {
         document.body.classList.remove("overflow-hidden");
       };
     }, []);
      const popupRef = useRef(null);
     
       useEffect(() => {
         // Function to handle click outside
         const handleClickOutside = (event) => {
           if (popupRef.current && !popupRef.current.contains(event.target)) {
            onClose();
           }
         };
     
         document.addEventListener("mousedown", handleClickOutside);
         return () => {
           document.removeEventListener("mousedown", handleClickOutside);
         };
       }, [onClose]);
return (
    <div className="fixed inset-0 flex items-center justify-center z-30 overflow-y-scroll backdrop-blur-sm bg-tertiary rounded">
      <div className="bg-tertiary p-11 md:p-6 rounded md:w-[50%] relative top-24 lg:top-7 text-center" ref={useRef}>
        
        {/* Close button */}
        <div className="absolute top-4 right-4">
          <FaTimes onClick={onClose} className="text-xl cursor-pointer text-white" />
        </div>
  
        {/* Centered Heading */}
        <h1 className="font-outfit text-2xl lg:text-3xl mb-4 text-white">YOUR ADDRESS HAS BEEN SAVED</h1>
  
        {/* Centered Image */}  
        <div className="flex justify-center">
          <img src={icons.addressSubmit} alt="Address Saved" className="w-24 lg:w-32 h:24 lg:h-32" />
        </div>
  
        {/* Centered Paragraph */}
        <p className="mt-4 text-md lg:text-lg text-white">
          Your address has been saved successfully, you're all set for a seamless checkout!
        </p>
        
      </div>
    </div>
  );
  
  
};

export default AddressSubmitPopup;
